import https from "./https";

const line = {
  searchUid(orgId, params) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    const searchParams = new URLSearchParams(params);

    return https.get(`/admin/organizations/${orgId}/line?${searchParams}`);
  },
};

export default line;
